import Layout from "layouts/Layout.vue"
import InnerLayout from "layouts/InnerLayout.vue"
// Home stays eager: it is the landing page and lazy-loading it would add a
// round-trip to first paint. Everything else is route-level lazy so the
// initial bundle stops shipping Highcharts (dashboard), the data-table lib
// and rarely-visited pages to every visitor.
import Home from "components/Home"

const Login = () => import("components/Login")
const Logout = () => import("components/Logout")
const Registration = () => import("components/Registration")
const NotFound = () => import("components/NotFound")
const Forgot = () => import("components/Forgot")
const Reset = () => import("components/Reset")
const Confirm = () => import("components/Confirm")
const Unsubscribe = () => import("components/Unsubscribe")
const FAQ = () => import("components/FAQ")
const Status = () => import("components/Status")
const Pricing = () => import("components/Pricing")
const Docs = () => import("components/Docs")
const Features = () => import("components/Features")
const MCP = () => import("components/MCP")
const StartApp = () => import("components/StartApp")
const Reviews = () => import("components/Reviews")
const TgComplete = () => import("components/TgComplete")
const Blog = () => import("components/Blog")
const BlogPost = () => import("components/BlogPost")
const WikiArticle = () => import("components/WikiArticle")
const Help = () => import("components/Help")
const Changelog = () => import("components/Changelog")
const Dashboard = () => import("components/inner/Dashboard")
const Tokens = () => import("components/inner/Tokens")
const Webhooks = () => import("components/inner/Webhooks")
const Billing = () => import("components/inner/Billing")
const Settings = () => import("components/inner/Settings")
const Plan = () => import("components/inner/Plan")
const ChoosePlan = () => import("components/inner/ChoosePlan")
const Pay = () => import("components/inner/Pay")

export default [
    {
        path: "/",
        name: "Outer",
        redirect: "/",
        component: Layout,
        children: [
            {
                path: "/login",
                name: "Login",
                component: Login,
                meta: {
                    title: "Login",
                    description: "Sign in to ASORadar to access the App Reviews API dashboard.",
                    noindex: true
                },
            },
            {
                path: "/forgot",
                name: "Forgot",
                component: Forgot,
                meta: {
                    title: "Forgot Password",
                    description: "Reset your ASORadar account password.",
                    noindex: true
                },
            },
            {
                path: "/reset/:uid/:token",
                name: "Reset",
                component: Reset,
                meta: {
                    title: "Reset Password",
                    noindex: true
                },
            },
            {
                path: "/confirm/:uid/:token",
                name: "Confirm",
                component: Confirm,
                meta: {
                    title: "Confirm Email",
                    noindex: true
                },
            },
            {
                path: "/unsubscribe/:uid/:token/:code",
                name: "Unsubscribe",
                component: Unsubscribe,
                meta: {
                    title: "Unsubscribe",
                    noindex: true
                },
            },
            {
                path: "/logout",
                name: "Logout",
                component: Logout,
                meta: {
                    title: "Logout",
                    noindex: true
                },
            },
            {
                path: "/registration",
                name: "Registration",
                component: Registration,
                meta: {
                    title: "Sign Up - Create Your Account",
                    description: "Create a free ASORadar account. Get 100 free API requests. Access App Store and Google Play reviews instantly.",
                    keywords: "sign up, register, create account, app reviews API, free trial"
                },
            },
            {
                path: "/tg-complete",
                name: "TgComplete",
                component: TgComplete,
                meta: {
                    title: "Complete Telegram Registration",
                    noindex: true
                },
            },
            {
                path: "/404",
                name: "404",
                component: NotFound,
                meta: {
                    title: "Page Not Found",
                    noindex: true
                },
            },
            {
                path: "/",
                name: "Home",
                component: Home,
                meta: {
                    title: "App Reviews API for Developers",
                    description: "Reviews, sentiment, app metadata, keyword rank tracking and webhooks for App Store and Google Play. Simple REST API, pay per request from $0.001.",
                    keywords: "App Store API, Google Play API, app reviews API, app reviews scraper, keyword rank tracking, ASO tools, app analytics API"
                },
            },
            {
                path: "/faq",
                name: "FAQ",
                component: FAQ,
                meta: {
                    title: "FAQ - Frequently Asked Questions",
                    description: "Common questions about ASORadar: pricing, rate limits, supported stores, and integration guides.",
                    keywords: "FAQ, frequently asked questions, app reviews API help"
                },
            },
            {
                path: "/status",
                name: "Status",
                component: Status,
                meta: {
                    title: "API Status - Service Health",
                    description: "Check ASORadar service status and health.",
                    keywords: "API status, service status, uptime"
                },
            },
            {
                path: "/docs",
                name: "Docs",
                component: Docs,
                meta: {
                    title: "API Documentation",
                    description: "ASORadar API documentation. Endpoints for App Store and Google Play reviews.",
                    keywords: "API docs, API documentation, app reviews API endpoints"
                },
            },
            {
                path: "/pricing",
                name: "Pricing",
                component: Pricing,
                meta: {
                    title: "Pricing - Pay Per Request",
                    description: "ASORadar pricing. Pay-as-you-go from $0.001 per request. Free trial with 100 requests.",
                    keywords: "API pricing, app reviews pricing, pay per request"
                },
            },
            {
                path: "/features",
                name: "Features",
                component: Features,
                meta: {
                    title: "Features - App Reviews API",
                    description: "Everything ASORadar can do: App Store and Google Play reviews, filters, full-text search, on-demand scraping, MCP integration.",
                    keywords: "app reviews API features, App Store API, Google Play API, scraping, full-text search"
                },
            },
            {
                path: "/mcp",
                name: "MCP",
                component: MCP,
                meta: {
                    title: "MCP - App Reviews from Claude, Cursor & AI assistants",
                    description: "Use ASORadar from Claude, Cursor, Codex, Zed, and Windsurf. The asoradar-mcp server exposes every endpoint as an MCP tool. Same key, same pricing.",
                    keywords: "MCP, Model Context Protocol, Claude, Cursor, Codex, app reviews MCP, asoradar-mcp"
                },
            },
            {
                path: "/startapp",
                name: "StartApp",
                component: StartApp,
                meta: {
                    title: "STARTAPP - From App Idea to Build-Ready Brief",
                    description: "Describe the app you wish existed. Your AI agent shortlists competitors, mines App Store and Google Play reviews for pain, and hands you a build brief: gap matrix, opportunities, opportunity score.",
                    keywords: "startapp, app idea validation, niche research, competitor analysis, review mining, gap matrix, build brief, MCP"
                },
            },
            {
                path: "/reviews",
                name: "Reviews",
                component: Reviews,
                meta: {
                    title: "Reviews - What developers say about ASORadar",
                    description: "Real testimonials from developers using ASORadar for App Store and Google Play review data.",
                    keywords: "ASORadar reviews, testimonials, customer reviews, app reviews API reviews"
                },
            },
            {
                path: "/blog",
                name: "Blog",
                component: Blog,
                meta: {
                    title: "Blog - Weekly Digest",
                    description: "Weekly industry digests covering App Store and Google Play reviews, ASO news, and platform changes.",
                    keywords: "App Reviews API blog, weekly digest, ASO news, app store updates"
                },
            },
            {
                path: "/blog/:slug",
                name: "BlogPost",
                component: BlogPost,
                meta: {
                    title: "Blog",
                },
            },
            {
                path: "/changelog",
                name: "Changelog",
                component: Changelog,
                meta: {
                    title: "Changelog - Latest Updates",
                    description: "ASORadar changelog. Latest updates, new endpoints, bug fixes, and improvements to the App Reviews API.",
                    keywords: "changelog, updates, release notes, ASORadar updates, app reviews API updates"
                },
            },
            {
                path: "/help",
                name: "Help",
                component: Help,
                meta: {
                    title: "Help Center",
                    description: "ASORadar Help Center — guides, policies, and product docs for the App Reviews API.",
                    keywords: "help, documentation, guides, ASORadar help, app reviews API help",
                },
            },
            {
                path: "/help/:pathMatch(.*)+",
                name: "WikiArticle",
                component: WikiArticle,
                meta: {
                    title: "Help Center",
                },
            },
        ]
    },
    {
        path: "/dashboard",
        name: "Inner",
        redirect: "/dashboard",
        component: InnerLayout,
        children: [
            {
                path: "",
                name: "Dashboard",
                component: Dashboard,
                meta: {
                    title: "Dashboard",
                    noindex: true
                },
            },
            {
                path: "/tokens",
                name: "Tokens",
                component: Tokens,
                meta: {
                    title: "Tokens",
                    noindex: true
                },
            },
            {
                path: "/webhooks",
                name: "Webhooks",
                component: Webhooks,
                meta: {
                    title: "Webhooks",
                    noindex: true
                },
            },
            {
                path: "/billing",
                name: "Billing",
                component: Billing,
                meta: {
                    title: "Billing",
                    noindex: true
                },
            },
            {
                path: "/billing/pay",
                name: "Pay",
                component: Pay,
                meta: {
                    title: "Top Up Balance",
                    noindex: true
                },
            },
            {
                path: "/plan",
                name: "Plan",
                component: Plan,
                meta: {
                    title: "Current Plan",
                    noindex: true
                },
            },
            {
                path: "/plan/choose/:id",
                name: "Choose plan",
                component: ChoosePlan,
                meta: {
                    title: "Choose Plan",
                    noindex: true
                },
            },
            {
                path: "/settings",
                name: "Settings",
                component: Settings,
                meta: {
                    title: "Settings",
                    noindex: true
                },
            },
        ]
    },
    {
        path: "/:pathMatch(.*)*",
        component: NotFound,
        meta: {
            title: "Page Not Found",
            noindex: true
        }
    }
]
